import React from 'react';
import PropTypes from 'prop-types';
import { PAYMENT_SUBJECT_CONFIG } from "../../../../constants/payment";
import { unformatPhone, unmaskPhoneFix } from "../../../../utils/formatters";
import { getCtnError } from "../../../../shared/PaymentForm/helpers";
export var Validation = function Validation(_ref) {
  var children = _ref.children,
    fromCtn = _ref.fromCtn,
    setFromCtnError = _ref.setFromCtnError;
  var validateCtn = React.useCallback(function () {
    var ctnVal = unmaskPhoneFix(unformatPhone(fromCtn));
    var error = getCtnError({
      ctn: ctnVal,
      paymentSubject: 'cellphone',
      paymentSubjectConfig: PAYMENT_SUBJECT_CONFIG
    });
    if (error) {
      setFromCtnError(error);
    } else {
      setFromCtnError('');
    }
    return error;
  }, [fromCtn, setFromCtnError]);
  return children({
    validateCtn: validateCtn
  });
};
Validation.propTypes = {
  fromCtn: PropTypes.string,
  children: PropTypes.func,
  setFromCtnError: PropTypes.func
};